export default {"src":"/_next/static/image/public/assets/icons/check.8a06cb7656320b205fee09b5a5175f5d.svg","height":20,"width":20};